module.exports = __webpack_public_path__ + "img/ResidentSupervise2.5d576635.png";